module.exports = __webpack_public_path__ + "img/banner.d5ef515e.png";